import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import Link from 'next/link'

interface PageCardProps {
	title: string
	subtitle: string
	buttonLabel: string
	url?: string
	image?: any
}

export default function PageCard({title, subtitle, url, image}: PageCardProps) {
	if (!url) {
		return (
			<div className="text-lg leading-110 group">
				<div>
					{image && (
						<Image
							className="w-full rounded-[8px] object-cover"
							src={image?.asset ? urlForImage(image).width(3840).url() : image?._upload?.previewImage}
							sizes='(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw'
							width={image?.asset?.metadata?.dimensions?.width || 0}
							height={image?.asset?.metadata?.dimensions?.height || 0}
							alt={title}
							placeholder="blur"
							blurDataURL={image?.asset?.metadata?.lqip || image?._upload?.previewImage}
							style={{
								aspectRatio: '16/9'
							}}
							quality={90}
						/>
					)}
				</div>
				<h3 className="mt-4">{title}</h3>
				<div className="mt-3 leading-120 text-grey dark:text-grey-dark">{subtitle}</div>
			</div>
		)
	}

	return (
		<Link href={url} className="text-lg leading-110 group">
			<div>
				{image && (
					<Image
						className="w-full rounded-[8px] object-cover"
						src={image?.asset ? urlForImage(image).width(3840).url() : image?._upload?.previewImage}
						sizes='(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw'
						width={image?.asset?.metadata?.dimensions?.width || 0}
						height={image?.asset?.metadata?.dimensions?.height || 0}
						alt={title}
						placeholder="blur"
						blurDataURL={image?.asset?.metadata?.lqip || image?._upload?.previewImage}
						style={{
							aspectRatio: '16/9'
						}}
						quality={90}
					/>
				)}
			</div>
			<h3 className="mt-4">{title}</h3>
			<div className="mt-3 leading-120 text-grey dark:text-grey-dark">{subtitle}</div>
		</Link>
	)
}
